import { Capacitor } from "@capacitor/core";
import { PushNotifications } from "@capacitor/push-notifications";
import api from "@/lib/api";

let status = "not started";
const listeners = new Set();
const setStatus = (s) => { status = s; listeners.forEach((f) => f(s)); };

export const pushStatus = () => status;
export const onPushStatus = (f) => { listeners.add(f); return () => listeners.delete(f); };

// Asks permission, registers with APNs/FCM and uploads the device token.
export async function registerPush() {
  try {
    setStatus("checking permission");
    let perm = await PushNotifications.checkPermissions();
    if (perm.receive === "prompt") perm = await PushNotifications.requestPermissions();
    if (perm.receive !== "granted") { setStatus(`permission ${perm.receive}`); return; }
    await PushNotifications.removeAllListeners();
    await PushNotifications.addListener("registration", async (t) => {
      setStatus("token received, uploading");
      try {
        await api.post("/push/register", { token: t.value, platform: Capacitor.getPlatform() });
        setStatus("registered");
      } catch (e) { setStatus(`upload failed: ${e.response?.status || e.message}`); }
    });
    await PushNotifications.addListener("registrationError", (e) => setStatus(`token error: ${e?.error || JSON.stringify(e)}`));
    setStatus("waiting for token");
    await PushNotifications.register();
  } catch (e) { setStatus(`error: ${e?.message || e}`); }
}
